import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { DEDUPER_FEATURE_GROUP } from './group';

export const DEDUPER_FEATURES = {
  ACCESS: {
    guid: '225d571d-1b8d-40a8-9de0-ffdb512b0001',
    name: 'deduper:access',
    description: 'Access the Deduper app',
    action: 'read',
    product: 'app',
    parentGuid: DEDUPER_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEDUPER_FEATURE_GROUP } from './group';

export const DEDUPER_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEDUPER_FEATURE_GROUP],
  features: featureList(DEDUPER_FEATURES),
};
